import request from '../request'

// ==================== 票据管理接口 Bill Controller ====================

// 查询票据列表
export function fetchBillList(params) {
    return request({
        url: '/finance-service/bill/list',
        method: 'get',
        params
    })
}

// 查询票据详情
export function fetchBillDetail(id) {
    return request({
        url: `/finance-service/bill/${id}`,
        method: 'get'
    })
}

// 票据登记（新增）
export function billAdd(data) {
    return request({
        url: '/finance-service/bill/add',
        method: 'post',
        data
    })
}

// 导出票据列表
export function exportBillList(data) {
    return request({
        url: '/finance-service/bill/export',
        method: 'post',
        data
    })
}

// 查询在手票据下拉选项
export function fetchBillOptions(params) {
    return request({
        url: '/finance-service/bill/options',
        method: 'get',
        params
    })
}

// 查询票据列表合计
export function fetchBillSum(params) {
    return request({
        url: '/finance-service/bill/sum',
        method: 'get',
        params
    })
}

// 编辑票据
export function billUpdate(data) {
    return request({
        url: '/finance-service/bill/update',
        method: 'post',
        data
    })
}

// 票据使用
export function billUse(data) {
    return request({
        url: '/finance-service/bill/use',
        method: 'post',
        data
    })
}

// 查询票据流转记录
export function fetchBillUseRecordList(params) {
    return request({
        url: '/finance-service/bill/use-record/list',
        method: 'get',
        params
    })
}

// 作废票据
export function billVoid(data) {
    return request({
        url: '/finance-service/bill/void',
        method: 'post',
        params: data
    })
}

// 删除票据
export function deleteBill(data) {
    return request({
        url: '/finance-service/bill/delete',
        method: 'post',
        params: data
    })
}
